import React, { useState, useEffect } from 'react';
import logo from '../../img/logo.png';
import '../../App.css';
import "../../style/Home.css";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ContactModal from '../Modals/ContactModal';
import { MenuOutlined } from '@ant-design/icons';
import MobileMenu from '../Modals/MobileMenu';
import { logEvent } from "firebase/analytics";
import { analytics } from "../../Firebase";
import ReactPixel from "react-facebook-pixel";

function Nav({ dashboard, menu, home, onOpenAuth }) {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const {
    currentUser,
    signout,
    changeLanguage,
    listProducts,
    language,
    currentRestaurant,
    languages,
    authReady,
  } = useAuth();

  const userLang = navigator.language || navigator.userLanguage;
  const userLangCode = userLang.split('-')[0];
  const isUserLangInLanguages = languages.some((language) => language.code === userLangCode);

  useEffect(() => {
    currentRestaurant?.defaultL === "false" && changeLanguage("en");
    currentRestaurant && isUserLangInLanguages && changeLanguage(userLangCode);
    currentRestaurant && !isUserLangInLanguages && userLangCode !== "fr" && changeLanguage("en");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRestaurant]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleLogoClick = () => {
    if (currentRestaurant?.id && menu) {
      navigate(`/shop/${currentRestaurant.id}/menu`);
      return;
    }

    navigate(`/`);
  };

  return (
    <header className={`${menu ? 'header2' : 'header'}`}>
      <img onClick={handleLogoClick} className='logo' src={logo} alt="/" />

      <div className={`${menu ? 'menu-side' : 'mobile-side'}`}>
        <button
          className='main-button mobile-main-button'
          aria-label="Ouvrir le formulaire de contact"
          onClick={() => setIsOpen(true)}
          style={{ display: 'none' }}
        >
          Essai gratuit
        </button>

        <MenuOutlined className='burger-menu' />
        <MobileMenu menu={menu} onOpenAuth={onOpenAuth} />
      </div>

      {menu && (
        <div className='burger-menu-right'>
          {listProducts && (
            <select
              style={{ display: 'none' }}
              className='select'
              id="language"
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              <option value="">Français</option>
              {languages?.map((language, index) => (
                <option key={index} value={language.code}>
                  {language.origin}
                </option>
              ))}
            </select>
          )}

          <MenuOutlined className='burger-menu' />
          <MobileMenu menu={menu} onOpenAuth={onOpenAuth} />
        </div>
      )}

      <div className='side-header mobile-user'>
        {!menu && home && authReady && (
          <p
            className='mobile-user'
            onClick={() => currentUser ? navigate(`/dashboard`) : navigate(`/login`)}
          >
            {currentUser ? 'Dashboard' : 'Se connecter'}
          </p>
        )}

        {!menu && !home && authReady && (
          <p className='mobile-user' onClick={signout}>
            Se déconnecter
          </p>
        )}

        {menu && listProducts && (
          <div style={{ display: 'none' }}>
            <select
              className='select'
              id="language"
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              <option value="">Français</option>
              {languages?.map((language, index) => (
                <option key={index} value={language.code}>
                  {language.origin}
                </option>
              ))}
            </select>
          </div>
        )}

        <div style={{ display: 'none' }}>
          <div className='side-header'>
            <span onClick={() => navigate(`/pricing`)}>Tarifs</span>
          </div>

          <div className='side-header'>
            <span onClick={() => navigate(`/blog`)}>Blog</span>
          </div>
        </div>

        {!home && authReady && currentUser && (
          <div className='side-header'>
            {!dashboard && (
              <span onClick={() => navigate(`/dashboard`)}>
                Dashboard
              </span>
            )}
            <span onClick={signout}>Se déconnecter</span>
            <img className='userlogo' src={currentUser?.photoURL} alt="/" />
          </div>
        )}

        {home && authReady && (
          <div className='side-header'>
            <span
              style={{ marginRight: 0 }}
              onClick={() => currentUser ? navigate(`/dashboard`) : navigate(`/login`)}
            >
              {currentUser ? 'Dashboard' : 'Se connecter'}
            </span>
          </div>
        )}

        {home && authReady && !currentUser && (
          <div className='side-header'>
            <button
              className='main-button'
              aria-label="Ouvrir le formulaire de contact"
              onClick={() => {
                navigate(`/login`);
                ReactPixel.track("Lead", { content_name: "Bouton Start" });
                logEvent(analytics, "Start");
              }}
            >
              Démarrer gratuitement
            </button>
          </div>
        )}
      </div>

      {isOpen && <ContactModal setIsOpen={() => setIsOpen(false)} />}
    </header>
  );
}

export default Nav;